var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSlime = function SvgSlime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "slime")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slime",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,14 L13,15 L3,15 L3,14 L13,14 Z M14,13 L14,14 L13,14 L13,13 L14,13 Z M3,13 L3,14 L2,14 L2,13 L3,13 Z M13,12 L13,13 L12,13 L12,12 L13,12 Z M2,7 L2,13 L1,13 L1,7 L2,7 Z M15,7 L15,13 L14,13 L14,7 L15,7 Z M10,11 L10,12 L6,12 L6,11 L10,11 Z M7,8 L7,10 L6,10 L6,8 L7,8 Z M10,8 L10,10 L9,10 L9,8 L10,8 Z M4,8 L4,9 L3,9 L3,8 L4,8 Z M3,5 L3,7 L2,7 L2,5 L3,5 Z M14,5 L14,7 L13,7 L13,5 L14,5 Z M6,5 L6,7 L4,7 L4,5 L6,5 Z M4,4 L4,5 L3,5 L3,4 L4,4 Z M13,4 L13,5 L12,5 L12,4 L13,4 Z M6,3 L6,4 L4,4 L4,3 L6,3 Z M12,3 L12,4 L10,4 L10,3 L12,3 Z M10,2 L10,3 L6,3 L6,2 L10,2 Z",
    fill: "#000000"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slime.269e22d6.svg";
export { ForwardRef as ReactComponent };